const {
  blockEditor: { useBlockProps, useInnerBlocksProps },
} = wp;

const DEFAULT_TAB_SLIDER_TAB_NAV_TEMPLATE = [
  ['core/heading', { level: 3, placeholder: 'Tab title' }],
];

const Edit = () => {
  const blockProps = useBlockProps();
  const { children, ...innerBlockProps } = useInnerBlocksProps(blockProps, {
    template: DEFAULT_TAB_SLIDER_TAB_NAV_TEMPLATE,
  });

  return (
    <>
      <div {...innerBlockProps}>{children}</div>
    </>
  );
};

export default Edit;
